/*jshint esversion: 6 */

(function () {
	'use strict';
	$(function () {

		window.setUrl = function (parameter, value) {
			var url = new Url();
			url.query[parameter] = value;
			window.history.replaceState(null, null, url.toString());
			$('.prettySocial').prettySocial();
			$('.linkedinSocial').linkedinSocial();
			window.updateFilterClicks();
		}


		$(document).ready(function () {

			$('.query-modifier').each(function () {
				var $this = $(this);
				var queryParameter = $(this).attr('id');
				$this.on('change', 'input[type=checkbox]', function () {
					if ( ($('body.industry').length) && $(this).prop('name') == 'regions') {
					} else {
						var selectedValues = [];
						$this.find('input:checked').each(function () {
							selectedValues.push($(this).val());
						});
						setUrl(queryParameter, selectedValues);
					}
				});
			});

			$('body').on('change', 'select.query-modifier', function () {
				var queryParameter = $(this).attr('id');
				setUrl(queryParameter, this.value);
			});

			$('body').on('change', 'input[type=radio].query-modifier', function () {
				if ( ($('body.industry').length) && $(this).prop('name') == 'size') {
				} else {
					var queryParameter = $(this).attr('name');
					var value = $('input[name=' + queryParameter + ']:checked').val();
					setUrl(queryParameter, value);
				}
			})

		});

	});
}(jQuery));
